import { useTranslation } from 'react-i18next'
import Dialog from 'components/Dialog'
import { Button, DatePicker, Form, Input, Row, Col } from 'antd'
import { useMutation } from '@apollo/client'
import { CREATE_MAIL } from 'pages/AddMail/mutations'
import { Domiciliation } from 'globals/models/Domiciliation'
import { UserMailTypeCategory } from 'graphql/mails/queries'
import popupSuccess from 'globals/popupSuccess'

interface ParcelValues {
  sender: string
  date: string
  weight: string
  dimensions: string
}

interface ClientParcelModalProps {
  visible: boolean
  onClose: () => void
  domiciliation: Domiciliation
  fetchMails: any
}

const ClientParcelModal: React.FC<ClientParcelModalProps> = ({ visible, onClose, domiciliation, fetchMails }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const [createParcel] = useMutation(CREATE_MAIL)

  const handleClose = () => {
    form.resetFields()
    onClose()
  }

  const onFinish = (values: ParcelValues) => {
    createParcel({
      variables: {
        domiciliationId: domiciliation.id,
        mailType: 'colis',
        weight: Number(values.weight),
        sendName: values.sender,
        dateOfReceipt: values.date
      }
    }).then(() => {
      fetchMails &&
        fetchMails({
          variables: {
            mailTypeCategory: UserMailTypeCategory.All,
            domiciliationId: domiciliation.id,
            page: 1,
            pageLength: 10
          }
        })
      handleClose()
      popupSuccess('Colis créé avec succès')
    })
  }

  return (
    <Dialog visible={visible} onClose={handleClose}>
      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>
        {t('clients.actions.parcel.title')}
      </div>
      <Form form={form} name='parcel' layout='vertical' onFinish={onFinish}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item name='sender' label={t('clients.actions.parcel.sender')}>
              <Input placeholder={t('clients.actions.parcel.sender')} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name='date' label={t('clients.actions.parcel.date')}>
              <DatePicker
                placeholder={t('clients.actions.parcel.date')}
                style={{ width: '100%' }}
                format={'DD/MM/YYYY'}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item name='weight' label={t('clients.actions.parcel.weight')}>
              <Input placeholder={t('clients.actions.parcel.weight')} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item name='dimensions' label={t('clients.actions.parcel.dimensions')}>
              <Input placeholder={t('clients.actions.parcel.dimensions')} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type='primary' htmlType='submit'>
            {t('global.confirm')}
          </Button>
        </Form.Item>
      </Form>
    </Dialog>
  )
}

export default ClientParcelModal
